import React, { useState, useEffect, useRef } from 'react';
import { postDataFetcher } from '../../dataFetcher';
import CONFIG_OBJECT from '../../config/config';
import LastPeriod from './due-date-calculator-landing-page/LastPeriod'
import dateUtils from '../../commonUtils/DateUtils';
import App_Constants from '../../app-constants/App_Constants';
import { withTranslation } from 'react-i18next';
import './due-date-calculator-css/due-date-calculator.css';
import './due-date-calculator-css/due-date-calculator-mobile.css';
import { isMobile } from 'react-device-detect';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import configData from '../../temp/config';
import Trimester from './due-date-calculator-result/Trimester';

let currentMonthCycle = {
	dayValue: new Date().getDate(),
	monthValue: new Date().getMonth(),
	yearValue: new Date().getFullYear(),
	cycleLength: 0,
	periodDuration: 0,
	selectedDate: '',
	isPeriodChange: false,
	isCycleChange: false
}


const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

const DueDateCalculator = (props) => {
	let domain = configData.sitecoreApiHost;
	const [showResultSection, setShowResultSection] = useState(false);
	const [disableBtn, setDisableBtn] = useState(true);
	const [disableAddBtn, setDisableAddBtn] = useState(true);
	const [showForm, setShowForm] = useState(true);
	const [showDesc, setShowDesc] = useState(isMobile ? false : true);
	const [parentCompData, setParentCompData] = useState({});
	const [componentData, setComponentData] = useState({})
	const [showDisabledInfo, setShowDisabledInfo] = useState(isMobile ? false : false)
	const [showDefaultCalender, setShowDefaultCalender] = useState(isMobile ? false : true)
	const [showEditForm, setShowEditForm] = useState(false);
	const [ovulationCalcData, setOvulationCalcData] = useState({
		showCalender: false,
		apiData: {},
		hasError: false,
		showDesc: true,
		showForm: true,
		showDefaultResult: true,
		showWarningSection: false,
		dueDateMsg: '',
		congratsMsg: ''
	});
	// Calling Layout Service and Caching the response 
	useEffect(() => {
		let componentData = props.fields;
		setComponentData(componentData);
		setParentCompData(props.fields);
	}, [])

	const calculatePeriod = () => {
		// if (enableBtn) {
		let month = Number(currentMonthCycle.monthValue) + 1;
		let data = {
			lastPeriodDate: `${dateUtils.formatDate(month)}-${dateUtils.formatDate(currentMonthCycle.dayValue)}-${currentMonthCycle.yearValue}`,
			periodDuration: Number(currentMonthCycle.periodDuration),
			cycleLength: `${currentMonthCycle.cycleLength}`,
		};

		if (isMobile) {
			setShowDesc(false)
			setShowForm(false)
		}
		let restURL = `${CONFIG_OBJECT.DDC_REST_URL}`;
		// Calling REST API Url
		postDataFetcher(`${restURL}${App_Constants.SC_API_KEY}&sc_lang=${localStorage.getItem('language')}`, data)
			.then(res => {
				let congrtsMsg = res.data.Data.resultMessage;
				if (res.data.HasError) {
					setOvulationCalcData({
						hasError: true
					})

				} else {
					setShowDefaultCalender(false);
					setOvulationCalcData({
						showCalender: true,
						apiData: res.data.Data,
						showForm: false,
						showWarningSection: data.periodDuration > 8,
						dueDateMsg: props.t('DueDateCalculator_ResultTitle').replace(`{0}`, res.data.Data.thirdTrimesterDate.toDateData.fullDate),
						congratsMsg: congrtsMsg
					});
				}
				setShowResultSection(true)
				setShowDisabledInfo(false)
				setDisableAddBtn(false);
			}, err => {
				setOvulationCalcData({
					hasError: true
				})
			});
		if (isMobile) {
			setShowEditForm(true)
		}
		if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;
	}

	// This function gets called whenever we changed anything in child component(Drop-down)
	const sendLastPeriodData = (dayValue, monthValue, yearValue, cycleLength, periodDuration, enableBtn, isPeriodChange, isCycleChange) => {
		currentMonthCycle = {
			dayValue: dayValue,
			monthValue: monthValue,
			yearValue: yearValue,
			cycleLength: cycleLength,
			periodDuration: periodDuration,
			isPeriodChange: isPeriodChange,
			isCycleChange: isCycleChange
		}
		console.log(currentMonthCycle)
		// if (currentMonthCycle.yearValue !== 1970)
		if (enableBtn) {
			setDisableBtn(false)
			document.getElementById("calculate-period-button-id").disabled = false;
		}
		document.getElementById("calculate-period-button-id").focus()
		//setDisableBtn(false);
	}

	const enableButton = () => {
		setDisableBtn(false);
	}

	const { t } = props;

	const showMainMenu = () => {
		setShowForm(true);
		setShowEditForm(false)
		setTimeout(function () { window.scrollTo(0, 0); }, 0);
		// setDisableBtn(true);
	}

	const mySubmitHandler = (e) => {
		e.preventDefault()
	}

	const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

	const formRef = useRef(null);
	const executeScroll = () => {
		scrollToRef(formRef)
	}
	let chooseAnotherGoalText = t('PeriodCalculator_ChooseAnotherGoal');
	const chooseAnotherGoalMobText = {
		__html: chooseAnotherGoalText
	}
	return (
		<>
			<div >
				{componentData.description &&
					<section id="main" data-test="component-ovulation">
						<div className="due-date-calculator">
							<div className="calculator-body">
								{showDesc &&
									<div className="container">
										<p className="ovulation-intro">
											{componentData.description.value}
										</p>
									</div>}
								<div className="goals-section container-mobile">
									{showEditForm &&
										<div className="recalculate-wrap-period-form">
											<div className="container">
												<div className="fdlp-mobile">
													<img src={`${configData.sitecoreApiHost}${parentCompData.firstIcon.value.src}`} />
													<span>{parentCompData.lastperiodLabel.value}</span><span>{currentMonthCycle.dayValue} {months[currentMonthCycle.monthValue]}, {currentMonthCycle.yearValue}</span>
												</div>
												<div className="cycle-length-mobile">
													<span>{parentCompData.periodDayLabel.value}</span><span>{currentMonthCycle.cycleLength} {props.t('PeriodCalculator_DaysLabel')}</span></div>
												<button onClick={showMainMenu}>
													<img src={`${configData.sitecoreApiHost}${parentCompData.secondIcon.value.src}`} />
													<span>Edit</span>
												</button>
											</div>
										</div>}
								</div>
								<div className={"form-container test"} ref={formRef}>
									{showForm && <form role="form" className="form-inline" onSubmit={mySubmitHandler}>
										<div className="toolform container">
											{<>
												<LastPeriod sendLastPeriodData={sendLastPeriodData}
													parentCompData={parentCompData}
													currentMonthCycle={currentMonthCycle} />
												<div className="submitBtnWrapper">
													<div className="dueDateBtnWrapper">
														<button type="submit" id="calculate-period-button-id" className="btn red calculate-button" onClick={calculatePeriod} disabled={disableBtn}>
															{t('DueDateCalculator_CalculateButton')}
														</button>
													</div>
												</div>
											</>}
										</div>
									</form>}
									{!isMobile &&
										<hr className="form-divider"></hr>
									}
									{showResultSection && <>
										<div className="container">
											<div className="result-section">
												<div className="due-date-social-share-component">
													<div className="email-share-container">
														<p className="share-email-text-msg">Share it with your family and friends!</p>
														<Placeholder name="social-share-result" rendering={props.rendering} itemid={props.itemid} />
													</div>
												</div>
												{ovulationCalcData.showCalender && <div className="calendar">
													<div className="higlight-dates">
														<span>{ovulationCalcData.dueDateMsg}</span>
														<p>{ovulationCalcData.congratsMsg}</p>
													</div>
													<div className="calendar-image">
														<div className="calendar-image-left-decor calandar-date-img-wrapper">
															<img src={domain + componentData.resultImageLeft.value.src} />
														</div>
														<div className="calendar-image-center-decor calandar-date-img-wrapper">
															<img src={domain + componentData.resultImageCenter.value.src} />
															<div className="calendar-date-details">
																<div className="calendar-text-details">
																	<p className="calendar-month-name">{ovulationCalcData.apiData.thirdTrimesterDate.toDateData.monthShortName}</p>
																	<p className="calendar-month-date">{ovulationCalcData.apiData.thirdTrimesterDate.toDateData.day}</p>
																	<p className="calendar-month-year">{ovulationCalcData.apiData.thirdTrimesterDate.toDateData.year}</p>
																</div>
															</div>
														</div>
														<div className="calendar-image-right-decor calandar-date-img-wrapper">
															<img src={domain + componentData.resultImageRight.value.src} />
														</div>
													</div>
													<div className="progress-bar-container">
														<Trimester trimesterData={ovulationCalcData.apiData.firstTrimesterDate} timesterNo={1} weeks={ovulationCalcData.apiData.weeks} />
														<Trimester trimesterData={ovulationCalcData.apiData.secondTrimesterDate} timesterNo={2} weeks={ovulationCalcData.apiData.weeks} />
														<Trimester trimesterData={ovulationCalcData.apiData.thirdTrimesterDate} timesterNo={3} weeks={ovulationCalcData.apiData.weeks} />
													</div>
												</div>}
											</div>
										</div>
									</>}
								</div>
							</div>
							<div className="social-share-container">
								<div className="container">
									<Placeholder name="social-share" rendering={props.rendering} itemid={props.itemid} />
								</div>
							</div>
						</div>

					</section>
				}
			</div>
			<div className="period-calculator-note-section">
				<p>{componentData.disclaimerMessage && componentData.disclaimerMessage.value}</p>
			</div>

		</>
	)
}

export default withTranslation()(DueDateCalculator);
